/**
 * Base class for experience behaviors.
 *
 * A Behavior defines the game rules and interaction logic for an experience.
 * Space provides the card primitives (select, drag, flip, focus, etc.);
 * Interaction routes input events to the active behavior's hooks.
 */
export default class Behavior {
    constructor(space, interaction, runtimeState = {}) {
        this.space = space;
        this.interaction = interaction;
        this.runtimeState = runtimeState || {};
    }

    // Lifecycle
    onSetup(cards) {}
    onDestroy() {}
    applyState(state) { this.runtimeState = state || {}; }
    canUseFocusToggle() { return true; }
    canUsePinchFocus() { return false; }

    // Input hooks (called by Interaction)
    onTap(card, position) {}
    onDoubleTap(card, position) {}
    onPanStart(card, position) { return false; }
    onPanMove(card, position) {}
    onPanEnd(card, position) {}
    onMouseMove(card, position) {}
    onScrollWheel(card, direction) {}
    onKeyDown(card, event) {}
    onKeyUp(event) {}
    onWindowBlur() {}

    // Remote event handlers — return { eventName: handler(data) }
    getRemoteHandlers() { return {}; }
}
